import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface IndexState {
  isDarkMode: boolean;
  mainLayout: string;
  theme: string;
  menu: string;
  layout: string;
  rtlClass: string;
  animation: string;
  navbar: string;
  locale: string;
  sidebar: boolean;
  languageList: any[];
  isShowMainLoader: boolean;
  semidark: boolean;
}

export const selectIndexState = createFeatureSelector<IndexState>('index');

export const selectLocale = createSelector(
  selectIndexState,
  (state) => state.locale
);
